import { sizes as commonSizes } from './common';

const baseStyle = () => ({
  container: {
    borderRadius: 'avatar',
    fontWeight: 'extrabold',
    color: 'black',
    '>img,>svg': {
      borderRadius: 'avatarInside',
      overflow: 'hidden',
    },
  },
});

function getSize(size: string) {
  return {
    container: {
      width: size,
      height: size,
      fontSize: `calc(${size} / 2.5)`,
    },
    excessLabel: {
      width: 'auto',
      px: '.4em',
      h: size,
      fontSize: '.9em',
      fontWeight: 'bold',
      rounded: 'avatar',
      bg: 'transparent',
    },
    label: {
      fontSize: `calc(${size} / 2.5)`,
      lineHeight: size !== '100%' ? size : undefined,
    },
  };
}

const sizes = {
  '5xs': getSize(commonSizes['5xs'].h),
  '4xs': getSize(commonSizes['4xs'].h),
  '3xs': getSize(commonSizes['3xs'].h),
  '2xs': getSize(commonSizes['2xs'].h),
  xs: getSize(commonSizes['xs'].h),
  sm: getSize(commonSizes['sm'].h),
  def: getSize(commonSizes['def'].h),
  md: getSize(commonSizes['md'].h),
  lg: getSize(commonSizes['lg'].h),
  xl: getSize(commonSizes['xl'].h),
  '2xl': getSize('96px'),
  '3xl': getSize('128px'),
  '4xl': getSize('160px'),
  '5xl': getSize('192px'),
  '6xl': getSize('224px'),
  '7xl': getSize('256px'),
};

export default {
  sizes,
  baseStyle,
};
